import { render, staticRenderFns } from "./SaleTicketPending.vue?vue&type=template&id=6a5e28c6&lang=pug&"
import script from "./SaleTicketPending.vue?vue&type=script&lang=js&"
export * from "./SaleTicketPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaleTicketPending.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
